import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Remove Emergent badge
const removeBadge = () => {
  const el = document.getElementById("emergent-badge");
  if (el) el.remove();
};
removeBadge();
// Also remove if injected later
const badgeObserver = new MutationObserver(removeBadge);
badgeObserver.observe(document.body, { childList: true, subtree: false });

// Register service worker for PWA
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
